export const IMAGE_STUDIO_EN = {
  // Header
  imageStudio: 'ImageStudio',
  generateImages: 'Generate Images',

  // Form
  promptLabel: 'Prompt',
  promptPlaceholder: 'Describe the image you want to generate...',
  modelPreset: 'Preset',
  modelFast: 'Vertex Imagen 4 Fast',
  modelNanoBananPro: 'Nano Banana Pro',
  aspectRatio: 'Aspect Ratio',
  numberOfImages: 'Number of Images',
  charactersCount: '{count}/5000 characters',
  showSettings: 'Show settings',
  hideSettings: 'Hide settings',
  loadingOptions: 'Loading options...',
  addFiles: 'Add Files',

  // Aspect ratios
  square: 'Square (1:1)',
  landscape: 'Landscape (16:9)',
  portrait: 'Portrait (9:16)',
  standard: 'Standard (4:3)',
  portraitStandard: 'Portrait (3:4)',

  // Gallery
  all: 'All',
  completedImages: 'Completed',

  // Empty states
  noImages: 'No images yet',
  noImagesDescription: 'Start generating AI images by entering a prompt below',
  noGenerating: 'No images generating',
  noCompleted: 'No completed images',

  // Card
  imageGenerationFailed: 'Generation failed',
  generationFailedTryAgain: 'Please try again.',
  previewUnavailable: 'Preview unavailable',
  previewExpiredTitle: 'Preview link expired',
  previewExpiredDescription: 'This image URL expired. Regenerate to create a fresh preview.',
  multipleImages: '+{count} more',

  // Preview modal
  imageDetails: 'Image Details',
  createdAt: 'Created',
  tpromptUsed: 'TPrompt',
  tpromptDefault: 'Default preset',

  // Status
  statusGenerating: 'Generating',

  // Actions
  deleteAllOutdatedImages: 'Delete outdated placeholders ({count})',
  deleteOutdatedConfirmTitle: 'Delete outdated placeholders',
  deleteOutdatedConfirmMessage:
    'Delete {count} outdated image card(s)? This removes broken preview links from your gallery.',
  deleteConfirmTitle: 'Delete Image',
  deleteConfirmMessage: 'Are you sure you want to delete this image? This action cannot be undone.',

  // Toast messages
  generationStarted: 'Image generation started',
  imageGenerationCompleted: 'Image generated successfully!',
  generationFailedToast: 'Image generation failed',
  imageDeleted: 'Image deleted',
  outdatedImagesDeleted: 'Deleted {count} outdated placeholder card(s).',
  outdatedImagesDeleteFailed: 'Failed to delete {count} outdated card(s).',
  downloadStarted: 'Downloading image...',
  promptTooShort: 'Prompt must be at least 3 characters',
  promptTooLong: 'Prompt must be less than 5000 characters',
  filesNotSupported: 'File attachments are not supported in Image Studio yet.',

  // Time formatting
  justNow: 'Just now',
  minutesAgo: '{count}m ago'
}
